// third-party
import { FormattedMessage } from "react-intl";
import {
  LocusAnalyticsDashboardsIcon,
  LocusReportsIcon,
} from "../assets/icons/LocusIcons.js";
import {
  CROSS_SITE_VIEWER,
  LOCUS_TENANT,
  VIEWER,
  SUPER_ADMIN,
} from "../utils/constants/user";
import * as React from "react";

// ==============================|| APPLICATION MENU ITEMS ||============================== //
/** @type {LocusMenuGroup} */
const analytics = {
  id: "analytics",
  title: <FormattedMessage id="analytics" />,
  type: "group",
  view: ["locus", "site"],
  children: [
    {
      id: "dashboards",
      title: <FormattedMessage id="dashboards" />,
      type: "item",
      icon: LocusAnalyticsDashboardsIcon,
      url: "dashboards?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "reports",
      title: <FormattedMessage id="reports" />,
      type: "item",
      icon: LocusReportsIcon,
      url: "reports?site=:siteId",
      allowedGroups: [LOCUS_TENANT, CROSS_SITE_VIEWER, VIEWER],
      view: ["site"],
    },
    {
      id: "locus-reports",
      title: <FormattedMessage id="reports" />,
      type: "item",
      icon: LocusReportsIcon,
      url: "reports",
      allowedGroups: [LOCUS_TENANT],
      view: ["locus"],
    },
    {
      id: "custom-dashboards",
      title: <FormattedMessage id="custom-dashboards" />,
      type: "collapse",
      icon: LocusAnalyticsDashboardsIcon,
      view: ["site"],
      children: [
        {
          id: "taskmap",
          title: <FormattedMessage id="taskmap" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_TASK_MAP}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "overview",
          title: <FormattedMessage id="overview" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_OVERVIEW}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "orderpool",
          title: <FormattedMessage id="orderpool" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_ORDER_POOL}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "associateperformance",
          title: <FormattedMessage id="associateperformance" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_ASSOCIATE_PERFORMANCE}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "directedassociateperformance",
          title: <FormattedMessage id="directedassociateperformance" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_DIRECTED_ASSOCIATE_PERFORMANCE}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "induction",
          title: <FormattedMessage id="induction" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_INDUCTION}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "openwork",
          title: <FormattedMessage id="openwork" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_OPEN_WORK}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "workassignment",
          title: <FormattedMessage id="workassignment" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_WORK_ASSIGNMENT}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "congestionmanagement",
          title: <FormattedMessage id="congestionmanagement" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_CONGESTION_MANAGEMENT}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "taskmap-overview",
          title: <FormattedMessage id="taskmap-overview" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_TASK_MAP_OVERVIEW}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "taskmap-workassignment",
          title: <FormattedMessage id="taskmap-workassignment" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_TASK_MAP_WORK_ASSIGNMENT}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
        {
          id: "overview-associateperformance",
          title: <FormattedMessage id="overview-associateperformance" />,
          type: "item",
          url: `custom-dashboards?site=:siteId&dashboard=${process.env.REACT_APP_DASHBOARD_OVERVIEW_ASSOCIATE_PERFORMANCE}`,
          breadcrumbs: true,
          view: ["site"],
          allowedGroups: [SUPER_ADMIN],
        },
      ],
    },
  ],
};

export default analytics;
